/**
 * Format seconds into mm:ss
 *
 * @param {Number} seconds
 *
 * @returns {String} The formatted time
 */
export default function formatCountdown(seconds) {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  return `${String(minutes).padStart(2, "0")}:${String(remainingSeconds).padStart(2, "0")}`;
}
